import { render } from "./TheMain.vue?vue&type=template&id=04e3efe4"
import script from "./TheMain.vue?vue&type=script&lang=js"
export * from "./TheMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__